// React y hooks
import React, { memo, useMemo } from 'react';

// Animación
import { motion } from 'framer-motion';

// Iconos
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaPlayCircle, FaEnvelope } from 'react-icons/fa';

// Estilos
import '../styles/vv-colors.css';
import '../styles/mobile-text-center.css';

// Componente AboutTest - Versión de prueba de la página Sobre Nosotros
const AboutTest = () => {
  return (
    <div className="page-container min-vh-100 p-0">
      {/* Sección 1: Hero - Sobre nosotros */}
      <section className="hero position-relative d-flex overflow-hidden w-100" style={{ height: '100vh', marginTop: '0' }}>
        {/* Background Image */}
        <div 
          className="position-absolute w-100 h-100" 
          style={{
            backgroundImage: `url('/images/sobre nosotros/secciones/hero_sobre_nosotros_optimized.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            top: 0,
            left: 0
          }}
        />
        
        {/* Background Overlay for better readability */}
        <div 
          className="position-absolute w-100 h-100" 
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            top: 0,
            left: 0,
            zIndex: 1
          }}
        />

        <div className="container position-relative" style={{ zIndex: 2, paddingTop: '20vh' }}>
          <div className="row align-items-center">
            {/* Content */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="col-lg-7 text-center text-lg-start"
            >
              <h1 className="display-4 fw-bold mb-3 text-center text-lg-start">
                <span className="text-vv-black">Sobre</span> <span className="text-vv-yellow">Nosotros</span>
              </h1>
              <h2 className="mb-4 text-center text-lg-start" style={{ fontSize: 'var(--font-xl)', letterSpacing: '0.5px', textTransform: 'uppercase', borderBottom: '2px solid var(--vv-yellow)', display: 'inline-block', paddingBottom: '8px', margin: '0 auto', marginLeft: 'auto', marginRight: 'auto' }}>
                Nuestra Historia y Misión
              </h2>
              <p className="lead text-spacing-lg text-center text-lg-start" style={{ color: 'var(--vv-text-dark)' }}>
                VV Health fue fundada por Viviana Rondinelli, una apasionada del <strong>bienestar</strong> y el <strong>branding</strong>, con el propósito de transformar la salud en Puerto Rico. La empresa nace para <strong>empoderar</strong> a profesionales de la salud a través del desarrollo de marcas privadas de suplementos y productos naturales.<br/><br/>
                Ayudamos a los profesionales a <strong>complementar</strong> sus tratamientos, <strong>fortalecer</strong> su práctica y <strong>generar</strong> un impacto real en sus comunidades. Con experiencia en <strong>salud</strong>, <strong>mercadeo</strong> y <strong>diseño</strong>, ofrecemos soluciones para quienes desean crear una marca con <strong>propósito</strong> y promover el <strong>bienestar integral</strong>.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
      
      <div className="container py-5">

        {/* Sección 2: Historia de la Fundadora */}
        <section className="py-5">
          <div className="mb-4">
            <h2 className="display-6 fw-bold mb-3 text-center text-md-start">Historia de la <span className="text-vv-yellow">Fundadora</span></h2>
            <div className="mx-auto mx-md-0" style={{ width: '100%', maxWidth: '200px', height: '2px', backgroundColor: 'var(--vv-yellow)', marginBottom: '2rem' }}></div>
            
            <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
              VV Health nace de una pasión profunda por la salud y el deseo genuino de marcar una diferencia en Puerto Rico.
            </p>
            
            <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
              Viviana Rondinelli, fundadora de VV Health, siempre soñó con una carrera en <strong>medicina</strong>. Desde pequeña sintió un llamado fuerte: ayudar a los demás a sentirse mejor. Aunque la vida la llevó por otro camino profesional —culminando estudios en <strong>Comunicaciones</strong> y una maestría en <strong>Mercadeo</strong>—, ese deseo de contribuir al bienestar de las personas nunca se apagó.
            </p>
            
            <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
              Durante años trabajó en empresas locales e internacionales, adquiriendo una valiosa experiencia en diferentes industrias. Sin embargo, su corazón siempre estuvo ligado al tema de la salud. Fue en octubre de 2024 cuando su vida profesional dio un giro inesperado, llevándola a reevaluar sus metas y redescubrir su verdadera vocación.
            </p>
            
            <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
              En medio de esa introspección nació una idea poderosa: <strong>crear un proyecto que uniera sus dos grandes pasiones: la salud y el branding</strong>. Así comenzó a estudiar la realidad de la salud en Puerto Rico, marcada por la falta de acceso a servicios médicos y la necesidad urgente de educación sobre prevención.
            </p>
            
            <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
              Tras conversar con médicos y analizar el panorama local, comprendió que muchas de las condiciones de salud que enfrentamos como país tienen raíz en una alimentación deficiente, el sedentarismo y la falta de herramientas accesibles para cuidar de nuestra salud día a día. Aquí es donde la suplementación —a través de vitaminas y productos naturales de calidad— cobra un papel esencial.
            </p>
            
            <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
              Así nació VV Health, con una misión clara:
              <br/><strong>"Empoderar a los profesionales de la salud para que provean un bienestar integral a través de productos de marca privada que complementen sus tratamientos y fortalezcan su impacto en la comunidad."</strong>
            </p>
            
            <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
              Este enfoque le permite a médicos, terapeutas, nutricionistas y otros profesionales recomendar suplementos y vitaminas que no solo complementen tratamientos médicos, sino que también promuevan la prevención y la calidad de vida del paciente.
            </p>
            
            <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
              Además, a través del desarrollo de <strong>marcas privadas</strong>, Viviana une el arte del diseño, la redacción y la conceptualización estratégica, ayudando a cada profesional a crear una línea de productos que represente su <strong>esencia</strong>, les brinde <strong>diferenciación</strong> y refuerce la <strong>confianza</strong> de sus pacientes.
            </p>
            
            <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
              VV Health no es solo una empresa: <strong>es el comienzo de una comunidad de líderes en bienestar comprometidos con transformar la forma en que cuidamos la salud en Puerto Rico</strong>.
            </p>
            
            <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
              Únete a esta misión y sé parte del cambio hacia una salud más accesible, consciente e integral.
            </p>
          </div>
        </section>

      </div>
      {/* Sección 3: Media/Video con efecto parallax a ancho completo - Fuera del contenedor */}
      <section className="w-100 overflow-hidden" style={{ height: '200px', margin: '3rem 0' }}>
        <div 
          className="w-100 h-100" 
          style={{ 
            backgroundImage: `url('/images/sobre nosotros/optimized/Background Video_optimized.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed' // Efecto parallax
          }}
        />
      </section>
      <div className="container py-5">

        {/* Sección 4: Nuestra Cultura */}
        <section className="py-5">
          <div className="row">
            <div className="col-lg-7">
              <h2 className="display-6 fw-bold mb-3 text-center text-md-start">Nuestra <span className="text-vv-yellow">Cultura</span></h2>
              <div className="mx-auto mx-md-0" style={{ width: '100%', maxWidth: '200px', height: '2px', backgroundColor: 'var(--vv-yellow)', marginBottom: '2rem' }}></div>
              
              <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
                Nuestra cultura se define en tres palabras: <strong>colaboración, respeto y comunicación</strong>.
              </p>
              
              <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
                <strong>Colaboración</strong>: creemos en la fuerza que se emana cuando diferentes personas colaboran para un mismo fin. Cada miembro del equipo aporta una perspectiva única, y cuando unimos talentos, experiencias y creatividad, logramos soluciones más sólidas y proyectos con propósito.
              </p>
              
              <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
                <strong>Respeto</strong>: Valoramos a cada persona por lo que es y lo que aporta. Fomentamos un ambiente donde se escucha, se reconoce y se aprecia el esfuerzo de todos. El respeto es la base para construir relaciones genuinas, tomar decisiones con empatía y crecer como equipo.
              </p>
              
              <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
                <strong>Comunicación</strong>: Promovemos el diálogo abierto, claro y honesto. Creemos que la confianza se construye hablando, escuchando y compartiendo ideas sin miedo. Una buena comunicación nos permite avanzar con claridad hacia nuestros objetivos comunes.
              </p>
              
              <p className="mb-3 text-center text-md-start" style={{ color: 'var(--vv-text-dark)' }}>
                En VV Health, estas tres palabras no son solo principios: son prácticas diarias que nos permiten <strong>trabajar con sentido, alcanzar metas juntos y crecer como profesionales y seres humanos</strong>.
              </p>
            </div>
            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <div className="rounded-4 shadow overflow-hidden" style={{ height: '300px', width: '100%', position: 'relative' }}>
                <video 
                  src="/images/sobre nosotros/Video Abeja.mp4" 
                  className="position-absolute"
                  style={{ 
                    objectFit: 'cover',
                    width: '100%',
                    height: '100%',
                    top: '0',
                    left: '0'
                  }}
                  autoPlay
                  loop
                  muted
                  playsInline
                  controls={false}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Sección 5: Redes Sociales */}
        <section className="py-5" style={{ 
          backgroundColor: 'var(--vv-bg-light)',
          borderRadius: '1rem',
          padding: '3rem 0'
        }}>
          <div className="row justify-content-center g-4">
            <div className="col-md-5">
              <div className="card border-0 shadow rounded-4 h-100 bg-white">
                <div className="card-body p-4 text-center">
                  <p className="mb-3" style={{ color: 'var(--vv-text-dark)' }}>
                    Conoce más sobre nosotros y los beneficios que las vitaminas aportan a tu salud a través de nuestra cuenta de Instagram.
                  </p>
                  <div className="d-flex justify-content-center gap-3 mb-3">
                    <a href="https://instagram.com/vvhealthpr" target="_blank" rel="noopener noreferrer" className="btn btn-light rounded-circle p-3">
                      <FaInstagram size={24} style={{ color: 'var(--vv-yellow)' }} />
                    </a>
                  </div>
                  <p className="fw-bold mb-0">@VVHealthPR</p>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="card border-0 shadow rounded-4 h-100 bg-white">
                <div className="card-body p-4 text-center">
                  <p className="mb-3" style={{ color: 'var(--vv-text-dark)' }}>
                    Si deseas ser parte del equipo o trabajar en una idea colaborativa, no dudes en comunicarte para ir por un café.
                  </p>
                  <div className="d-flex justify-content-center gap-3 mb-3">
                    <a href="mailto:info@VVHealthPR.com" className="btn btn-light rounded-circle p-3">
                      <FaEnvelope size={24} style={{ color: 'var(--vv-yellow)' }} />
                    </a>
                  </div>
                  <p className="fw-bold mb-0">info@VVHealthPR.com</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

// Memorizar el componente para evitar renderizados innecesarios
export default memo(AboutTest);